import React, { useState } from "react"
import { useNavigate } from "react-router";
import { ModalComp } from "../../components";
import { useAppDispatch } from "../../redux/Hooks/Hook";
import { AllFacilitiesList } from "../../redux/Slice/Facilities/FacilitiesListSlice";
import { DeleteFacility } from "../../utilities/api/Facilities";

const ArchiveFacilities = ({ archive, setArchive, id }: any) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [message, setMessage] = useState("")
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = async () => {
    if (isDeleting) return
    setIsDeleting(true)
    const result = await DeleteFacility(id)
    if (result?.status === 200) {
      setArchive(false)
      navigate("/facilities")
      dispatch(AllFacilitiesList(""))
    }
    if (result?.response?.status) {
      setMessage(result.response.data.message)
    }
    setIsDeleting(false)
  }
  return (
    <ModalComp archive={archive} setArchive={setArchive} handleDelete={handleDelete} message={message} isDeleting={isDeleting} />
  )
}

export { ArchiveFacilities }